import * as d3 from 'd3'
import { Component } from 'react'

import { Icon } from '../../main/components/icon'
import ActionCreators from './actions/bubbleActionCreators'
import HoverStore from './stores/hoverStore'

interface LegendProps {
  colorFn: any
}

class Legend extends Component<LegendProps> {
  state = { color: null }
  componentDidMount() {
    HoverStore.addChangeListener(this._handleStateUpdate)
  }

  componentWillUnmount() {
    HoverStore.removeChangeListener(this._handleStateUpdate)
  }

  _handleStateUpdate = () => {
    this.setState({ color: HoverStore.getHoveredColor() })
  }

  render() {
    var domain = this.props.colorFn.domain()
    const isNumberDomain = domain.every((d: any) => Number.isFinite(d))
    var steps = domain
    if (domain.length === 2 && isNumberDomain) {
      steps = [Math.round(domain[0] * 10) / 10]
      var diff = Math.round(domain[1] * 10) / 10 - steps[0]
      var step = diff / 6
      for (var i = 1; i < 7; i++) {
        steps.push(Math.round((steps[0] + step * i) * 10) / 10)
      }
    }

    /*if (this.props.scale.id === '_rec') {
            steps = [5, 4, 3, 2, 1];
        }*/

    var onlyPositive = domain[0] >= 0 && domain[1] >= 0
    return (
      <div className="flex justify-between pl-5" data-testid="map-legend-container">
        <div className="mr-5 flex min-w-[300px] pt-3 text-[11px] text-[#707990]">
          <Icon name="help" className="mr-1 mt-0.5 shrink-0" /> Double-click on a bubble to display detailed information
          in a new window.
        </div>
        <div className="mt-2 flex flex-wrap items-start justify-end text-2xs font-normal">
          {steps.map((step: any) => {
            var n = step
            if (step > 1 || step < -1) {
              n = d3.format('.2s')(step).replace('G', 'B')
            }
            n = (step > 0 && !onlyPositive ? '+' : '') + n
            var format = '%N' //scaleStepFormat[this.props.scale.id];
            if (typeof format !== 'string') {
              format = format[n]
            }

            var rgb = d3.rgb(this.props.colorFn(step))
            var style = {
              background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + 0.85 + ')',
              width: domain.length === 2 && isNumberDomain ? 50 : 'auto',
              paddingLeft: 6,
              paddingRight: 6,
              textShadow: '0px 1px 0 rgba(0,0,0,0.25)',
              opacity: !this.state.color || this.state.color === n ? 1 : 0.4,
            }
            return (
              <div
                className="ml-px mt-px whitespace-nowrap text-center leading-6 text-white"
                style={style}
                key={n}
                onMouseEnter={() => {
                  if (steps.length > 1) {
                    ActionCreators.setHoveredColor(step)
                  }
                }}
                onMouseOut={() => {
                  ActionCreators.setHoveredColor(null)
                }}
              >
                {format.replace('%N', n)}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default Legend
